<div class="pageheader">
  <div class="page-title">
    <h1>Formats</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Formats log'">
        <app-change-log-link-entity type="Format"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="container container-fixed">
  <div class="row">
    <div class="col-sm-12">
      <dx-data-grid biz-grid
        [selection]='{ mode: "none" }'
        [dataSource]='formats'
        [bizSetColumnChooser]="true"
        [bizSetAllowColumnReordering]="false"
        [bizSetPager]="false"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onRowRemoving)="onRowRemoving($event)"
        (onEditingStart)="onEditingStart($event)"
        (onRowValidating)="onRowValidating($event)"
        [bizEditRowOnDoubleClick]="true">

        <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
        </dxo-editing>

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxi-column dataField="FormatName" caption="Name" dataType="string" width="50%" sortOrder="asc" [allowGrouping]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>

        <dxi-column dataField="FormatTypesId" caption="Format type" width="50%" editCellTemplate="singleDropDownBoxEditor">
          <dxo-lookup [dataSource]="formatTypes" valueExpr="Id" displayExpr="Name"></dxo-lookup>
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getFormatTypeFilterData(bizGridFiltervalues.getPropertyValues(this.formats, 'FormatTypesId'), formatTypes)"/>
        </dxi-column>

        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.formats, 'CreatedBy'))"></dxo-header-filter></dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="true" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.formats, 'UpdatedBy'))"></dxo-header-filter></dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

        <dxi-column type="buttons">
          <dxi-button name="edit"></dxi-button>
          <dxi-button name="delete"></dxi-button>
          <dxi-button text="Show Log"
            template="logTemplate"
            [visible]="allowShowLog">
          </dxi-button>
        </dxi-column>

        <ng-container *dxTemplate="let cell of 'logTemplate'">
          <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.FormatName" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="Format" [id]="cell.data.FormatsId"></app-change-log-link-entity>
          </app-change-log-link>
        </ng-container>

        <div *dxTemplate="let cellInfo of 'singleDropDownBoxEditor'">
          <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="formatTypes"
            [(value)]="cellInfo.value" displayExpr="Name" valueExpr="Id"
            contentTemplate="contentTemplate">
            <div *dxTemplate="let e of 'contentTemplate'">
              <dx-data-grid [dataSource]="formatTypes" [remoteOperations]="true" [height]="250"
                [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true"
                [focusedRowKey]="cellInfo.value" [hoverStateEnabled]="true" keyExpr="Id"
                (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
                <dxi-column caption="Name" dataField="Name" sortOrder="asc"></dxi-column>
                <dxi-column caption="Default ext." dataField="DefaultExtension"></dxi-column>
                <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
                <dxo-selection mode="single"></dxo-selection>
              </dx-data-grid>
            </div>
          </dx-drop-down-box>
          @if (selectedFormatType?.DisassemblerInitStepId && formatTypeDisassemblerDataFields.length > 0) {
            <div>
              <dx-check-box
                [value]="overrideDisassemblerConfig"
                [enableThreeStateBehavior]="false"
                text="Override disassembler configuration?"
                iconSize="25"
                (onValueChanged)="onValueChanged($event)">
              </dx-check-box>
            </div>
          }

          @if (overrideDisassemblerConfig && formatTypeDisassemblerDataFields.length > 0) {
            <ep-datafield-group-container [formValidationGroup]="formatTypeDisassemblerFormGroup" [showError]="true" [datafieldGroups]="formatTypeDisassemblerDataFields" [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
          }
        </div>

      </dx-data-grid>
    </div>
  </div>
</div>
